import { useAuth } from '@practium/features/auth';
import { useForBinding } from '@practium/features/forBinding';
import { useGetMe } from '@practium/features/api';
import type { NavbarConfig } from '@practium/ui';
import { FloraNavbarTitle } from '@practium/features/flora-ai';
import userAvatar from '/avatars/user-avatar.png';
import { useLocation, useNavigate } from 'react-router-dom';
import { OcrQueueNavbarButton } from '../../analyses/components/OcrQueueWidget/OcrQueueNavbarButton';
import { mockDossierDocuments, mockFloraChats } from '@practium/features/flora-ai';

const ROLE_LABELS: Record<string, string> = {
	farmer: 'Agricultor',
	consultant: 'Consultor',
	company: 'Empresa',
	admin: 'Administrador',
	master: 'Master',
};

export const useClientNavbarConfig = (): NavbarConfig => {
	const { user } = useAuth();
	const { isForBinding, forBindingUser } = useForBinding();
	const { data: me } = useGetMe();
	const navigate = useNavigate();
	const { pathname } = useLocation();
	const isFloraPage = pathname === '/flora-ai';

	const effectiveRole = isForBinding ? forBindingUser?.role : user?.role;
	const effectiveName = isForBinding
		? `${forBindingUser?.name ?? ''} ${forBindingUser?.surName ?? ''}`.trim()
		: user?.name;

	const roleLabel = ROLE_LABELS[effectiveRole ?? ''] ?? 'Usuário';

	const avatarUrl = isForBinding
		? forBindingUser?.avatar?.url || userAvatar
		: me?.avatar?.url || userAvatar;

	return {
		title: 'Dashboard',
		titleContent: isFloraPage
			? (
				<FloraNavbarTitle
					dossierCount={mockDossierDocuments.length}
					chats={mockFloraChats}
					activeChatId={mockFloraChats[0]?.id}
					onNewConversation={() => {}}
					onSelectChat={() => {}}
				/>
			)
			: undefined,
		centerContent: isFloraPage ? undefined : <OcrQueueNavbarButton />,
		user: {
			name: effectiveName || 'Usuário',
			avatar: avatarUrl,
			role: roleLabel,
		},
		onSearch: (_query: string) => { },
		onNotificationClick: () => { },
		onUserMenuClick: () => {
			navigate('/perfil');
		},
		notificationCount: 3,
	};
};
